// extracted by mini-css-extract-plugin
export default {"background":"Modal_background__6RWis","fadeIn":"Modal_fadeIn__wyAoj","box":"Modal_box__54xLx","header":"Modal_header__9eKcl"};